import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  signout(): void {
    localStorage.clear();
    console.log('User signed out and session token cleared.');
  }

  setAccessToken(key: string, value: string) {
    localStorage.setItem(`${key}`, `${value}`);
  }

  setIdToken(key: string, value: string) {
    localStorage.setItem(`${key}`, `${value}`);
  }

  setItem(key: string, value: string) {
    localStorage.setItem(`${key}`, `${value}`);
  }

  getIdToken() {
    return localStorage.getItem(`id_token`);
  }

  getItem(key: string): any {
    return localStorage.getItem(`${key}`);
  }

  logAllItems(): void {
    console.log('Current localStorage contents:');
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        const value = localStorage.getItem(key);
        console.log(`${key}: ${value}`);
      }
    }
  }
}
